import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
    // baseURL: 'http://localhost:3031/geo-localizacao/incontre'
    // baseURL: 'https://portal-cliente.integrati.solutions/api'
});

export default instance;
